import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import logo from '@/assets/damian-keyes-logo.png';

/**
 * Draft confirmation route. Payment verification is not connected, so this page never
 * claims a payment was received and the start-preference form cannot submit or store data.
 */
const field = 'w-full rounded-md bg-white border border-[#101114]/20 px-3 py-2.5 text-[#101114] disabled:opacity-60';

export default function BlackFridayConfirmed() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FFFFFF', color: '#101114' }}>
      <Helmet>
        <title>Artist Kickstart | DK Artists</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <header className="max-w-5xl mx-auto px-6 h-16 flex items-center">
        <Link to="/" aria-label="DK Artists home"><img src={logo} alt="DK Artists" className="w-44 h-auto" /></Link>
      </header>
              <main className="max-w-2xl mx-auto px-6 pt-10 pb-24">
          <div role="status" className="border-l-2 border-[#0071E3] bg-white px-4 py-3 text-sm text-[#101114]/80">
            Draft preview. Payment confirmation isn't connected yet, so this page can't confirm a purchase and the form below is inactive.
          </div>
                    <h1 className="mt-10 font-headline font-bold text-[clamp(2rem,5vw,3rem)] leading-[1.08] tracking-[-0.03em]">Let's get your kickstart set up.</h1>
          <p className="text-[#101114]/70 text-lg leading-relaxed mt-5">Once your payment is confirmed, you'll be able to tell us when you'd prefer to start, and our team will arrange the next steps with you.</p>

          <form className="mt-10" onSubmit={(e) => e.preventDefault()} aria-describedby="draft-note">
            <fieldset disabled className="space-y-6">
              <div>
                <legend className="font-semibold">When would you like to start?</legend>
                <div className="mt-3 space-y-2 text-[#101114]/70">
                  {['As soon as possible.', 'In January 2027.', 'I would like to agree another date with the team.'].map((o) => (
                    <label key={o} className="flex items-center gap-3"><input type="radio" name="start" /> {o}</label>
                  ))}
                </div>
              </div>
              <label className="block text-sm text-[#101114]/70">Optional preferred date or note<textarea className={`${field} mt-1.5`} rows={3} /></label>
              <label className="block text-sm text-[#101114]/70">Your time zone<input className={`${field} mt-1.5`} /></label>
              <label className="block text-sm text-[#101114]/70">Artist or project name<input className={`${field} mt-1.5`} /></label>
              <label className="block text-sm text-[#101114]/70">Music or social link (optional)<input className={`${field} mt-1.5`} /></label>
              <button type="submit" className="w-full rounded-lg bg-[#0071E3] text-white font-semibold py-3.5 disabled:opacity-50 disabled:cursor-not-allowed">Send my preference</button>
            </fieldset>
            <p id="draft-note" className="text-xs text-[#101114]/50 mt-4">This is a preference, not a confirmed appointment. Your kickstart begins on the date agreed with the team.</p>
          </form>
          <Link to="/black-friday" className="inline-block mt-10 text-sm text-[#101114] underline underline-offset-4 decoration-[#0071E3]">Back to the Artist Kickstart</Link>
        </main>
          </div>
  );
}
